@if (title(); as titleText) {
  <rt-heading class="title" variant="heading semi-bold">{{ titleText }}</rt-heading>
}

@if (hasRows()) {
  <div class="scroll" [style.--cols]="cols().length">
    <rt-data-table
      [cols]="cols()"
      [rows]="rows()"
      [raised]="false"
      [hasZebra]="true"
      (sortChange)="onSortChange($event)"
    />
  </div>

  @if (totalPages() > 1) {
    <footer class="pagination">
      <rt-icon-button
        iconName="chevron-left"
        variant="plain"
        [disabled]="!canPrev()"
        (click)="prevPage()"
      />
      <span class="pagination-label">{{ page() + 1 }} / {{ totalPages() }}</span>
      <rt-icon-button
        iconName="chevron-right"
        variant="plain"
        [disabled]="!canNext()"
        (click)="nextPage()"
      />
    </footer>
  }
}
